export class GetAwsPrivateLinkStatusResponse {
    'status';
    'ramShareArn';
    'updatedAt';
    'tearDownStartedAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "GetAwsPrivateLinkStatusResponseStatusEnum",
            "format": ""
        },
        {
            "name": "ramShareArn",
            "baseName": "ramShareArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "tearDownStartedAt",
            "baseName": "tearDownStartedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GetAwsPrivateLinkStatusResponse.attributeTypeMap;
    }
    constructor() {
    }
}
export var GetAwsPrivateLinkStatusResponseStatusEnum;
(function (GetAwsPrivateLinkStatusResponseStatusEnum) {
    GetAwsPrivateLinkStatusResponseStatusEnum["NotSetup"] = "not_setup";
    GetAwsPrivateLinkStatusResponseStatusEnum["InProgress"] = "in_progress";
    GetAwsPrivateLinkStatusResponseStatusEnum["Active"] = "active";
    GetAwsPrivateLinkStatusResponseStatusEnum["TearingDown"] = "tearing_down";
})(GetAwsPrivateLinkStatusResponseStatusEnum || (GetAwsPrivateLinkStatusResponseStatusEnum = {}));
